export const BEGIN_TICKET_SUBMIT = 'BEGIN_TICKET_SUBMIT'
export const TICKET_SUBMIT_SUCCESS = 'TICKET_SUBMIT_SUCCESS'
export const TICKET_SUBMIT_FAILURE = 'TICKET_SUBMIT_FAILURE'

function beginTicketSubmit() {
  return { type: BEGIN_TICKET_SUBMIT }
}

function ticketSubmitSuccess() {
  return { type: TICKET_SUBMIT_SUCCESS }
}

function ticketSubmitFailure() {
  return { type: TICKET_SUBMIT_FAILURE }
}

export function submitServiceTicket(st) {
  return dispatch => {
    dispatch(beginTicketSubmit())
    return fetch(`/users/service?ticket=${st}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(response =>{
      if((response.status >= 300 && response.status <= 399) || response.ok) {
        dispatch(ticketSubmitSuccess())
      } else {
        dispatch(ticketSubmitFailure('Sorry, something went wrong!'))
      }
    })
    .catch(error => dispatch(ticketSubmitFailure(error.message)))
  }
}
